
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function BlogSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section 
      id="blog" 
      ref={ref}
      className={`py-12 sm:py-16 md:py-24 relative transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/a8678b23ab17c6de2b1145a1d66ae125.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-3 sm:mb-4 sm:mb-6 px-2">
            {t('blog.title')}
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-white/90 max-w-3xl mx-auto leading-relaxed px-4">
            {t('blog.subtitle')}
          </p>
        </div>
        
        <div className="grid gap-4 sm:gap-6 lg:gap-8 sm:grid-cols-2 lg:grid-cols-3 px-2 sm:px-0">
          {/* Espacios vacíos para futuros artículos */}
        </div>
      </div>
    </section>
  );
}
